<ng-container *ngIf="(breakPointService.device$ | async) === device.MOBILE; then mobileTemplate; else desktopTemplate">
</ng-container>
<ng-template #mobileTemplate>
	<button cdxButton size="large" fillStyle="outline" [fullWidth]="true" (click)="loadMore()" *ngIf="showPagination">
		Load more products
	</button>
</ng-template>

<ng-template #desktopTemplate>
	<search-pagination
		[currentPage]="currentPage"
		[currentPageSize]="currentPageSize"
		[itemsPerPageCollection]="itemsPerPageCollection"
		[totalItems]="totalItems"
		[canChangePageSize]="canChangePageSize"
	></search-pagination>
	<button cdxButton (click)="scrollToTop()">Back to top</button>
</ng-template>
